export const createTempId = () => `TEMP__${Math.floor(Math.random() * 99999)}`;
